import React, { Component } from 'react'
import PropTypes from 'prop-types'
// import cn from 'classnames'
import gql from 'graphql-tag'
// import { graphql } from 'react-apollo/index'
import { Query, graphql, compose } from 'react-apollo'
import get from 'lodash/get'

// import Count from '../common/Count'
import QuestionLeft from '../common/QuestionLeft'
import TimeAgo from '../common/TimeAgo'
import { submissionsClosed } from '../../utils'

import Avatar from '../common/Avatar'

import styles from './Question.module.css'
import cn from "classnames";
// import Comments from "../Comments";
import InlineComments from "../InlineComments";
import {COMMENTS_PER_PAGE} from "../../config";
import AddComment from "../Board/AddComment";

class Question extends Component {
  state = {
    isApproved: this.props.question.isApproved,
    isRejected: this.props.question.isRejected,
    isUpvotedByMe: this.props.question.isUpvotedByMe,
    upvotes: this.props.question.upvotes,
    downvotes: this.props.question.downvotes,
    error: null,
  }

  handleModeration = async (uuid, approve) => {
    // const result = await this.props.mutate({
    const result = await this.props.moderate({
      variables: {
        uuid: uuid,
        approve: approve,
      },
    })

    const resp = get(result, 'data.moderate')
    if (resp.success) {
      this.setState({
        isApproved: approve,
        isRejected: !approve,
      })
    } else {
      this.setState({
        error: resp.message,
        isApproved: resp.approved,
        isRejected: !resp.approved,
      })
    }
  }

  handleVote = async (uuid, isUp) => {
    // const result = await this.props.mutate({
    const result = await this.props.vote({
      variables: {
        questionUuid: uuid,
        isUp: isUp,
      },
    })

    const resp = get(result, 'data.vote')
    if (resp.success) {
      this.setState({
        // isUpvotedByMe: resp.isUpvotedByMe,
        // upvotes: resp.upvotes,
        // downvotes: resp.downvotes
        isUpvotedByMe: resp.question.isUpvotedByMe,
        upvotes: resp.question.upvotes,
        downvotes: resp.question.downvotes
      })
    } else {
      this.setState({
        error: resp.message
      })
    }
  }


  renderModeration = (board, question) => {
    const { uuid } = question
    const { isApproved, isRejected } = this.state
    if (isApproved) {
      return <span className="text-muted"><i className="fas fa-check-circle jelly-color-success mr-2 pdf-no-export"></i><span className="">Approved</span></span>
      // return <div className={cn('', styles.approvedBadge)}><i className="fas fa-check-circle jelly-color-success"></i><span className="ml-2"> Approved</span></div>
    } else if (isRejected) {
      return <div className={styles.rejectedBadge}><i className="fas fa-times-circle jelly-color-danger"></i><span className="ml-2">Rejected</span></div>
    } else if (submissionsClosed(board)) {
      return (
        <div className={styles.archivedBadge}>
          Submissions closed, neither approved nor rejected
        </div>
      )
    } else {
      return (
        <div>
          <button
            className="btn btn-sm btn-success"
            onClick={() => this.handleModeration(uuid, true)}
          >
            Approve
          </button>
          &nbsp;
          <button
            className="btn btn-sm btn-danger"
            onClick={() => this.handleModeration(uuid, false)}
          >
            Reject
          </button>
        </div>
      )
    }
  }

  buildQuestionUrl = (uuid) => {
    return '/question/'+uuid+'';
  }

  gotoQuestionUrl = (uuid) => {
    window.location = this.buildQuestionUrl(uuid);
  }

  render() {
    const { board, question, isLast } = this.props
    const { error } = this.state

    var settings = get(board, 'organization.settings', "")
    var settingsObj = JSON.parse(settings)
    var excludeComment = settingsObj.exclude_comment
    var excludeUpvote = settingsObj.exclude_upvote
    var excludeDownvote = settingsObj.exclude_downvote

    const {
      uuid,
      title,
      description,
      upvotes,
      downvotes,
      isUpvotedByMe,
      // isDownvotedByMe,
      creatorDisplayName,
      created,
      commentCount,
      image,
      permalink,
      comments
    } = question

    return (
        <div className={cn('question-row row py-3 border-bottom border-medium', this.state.isApproved !== true ? 'pdf-no-export' : '', { '': !isLast })}>
        {/*<div className={cn('question-row row py-3', this.state.isApproved !== true ? 'pdf-no-export' : '', { 'border-bottom border-medium': !isLast })}>*/}

      {/*<div className={cn('question-row row border-bottom border-medium py-3', this.state.isApproved !== true ? 'pdf-no-export' : '')}>*/}
        {/*<div className="row border-bottom border-medium py-3">*/}

        {/*<QuestionLeft*/}
          {/*image={image}*/}
          {/*isUpvotedByMe={isUpvotedByMe}*/}
          {/*upvotes={upvotes}*/}
          {/*downvotes={downvotes}*/}
          {/*commentCount={commentCount}*/}
        {/*/>*/}

        <div className="col-1 d-inline-flex flex-column align-items-center">
          <div className="pb-2">
            <Avatar src={image} />
          </div>
          {this.state.isApproved && !excludeUpvote && (<button type="button"
                                        className={cn('btn btn-sm btn-pill btn-ghost-info', this.state.isUpvotedByMe === true ? 'jelly-color-primary' : 'jelly-color-gray-500')}
                                        onClick={() => this.handleVote(uuid, true)}>
            <i className="fas fa-thumbs-up"></i><span className="ml-2">{this.state.upvotes}</span>
            </button>)
          }
          {this.state.isApproved && !excludeDownvote && (<button type="button"
                                      className={cn('btn btn-sm btn-pill btn-ghost-info', this.state.isUpvotedByMe === false ? 'jelly-color-primary' : 'jelly-color-gray-500')}
                                      onClick={() => this.handleVote(uuid, false)}>
            <i className="fas fa-thumbs-down"></i><span className="ml-2">{this.state.downvotes}</span>
            </button>)
          }
          {/*<button type="button" className={cn('btn btn-sm btn-pill btn-ghost-info jelly-color-gray-500')}*/}
          {/*        onClick={() => this.gotoQuestionUrl(uuid)}>*/}
          {/*        /!*href={this.buildQuestionUrl(uuid)}>*!/*/}
          {/*  <i className="fas fa-comment-alt"></i><span className="ml-2">{commentCount}</span>*/}
          {/*</button>*/}
          {/*{!submissionsClosed(data.getQuestion.board) && (<AddComment buttonType="icon" board={board} question={question} onCloseRefreshHandler={() => refetch()} />)}*/}
          {/*{!submissionsClosed(board) && (<AddComment buttonType="icon" commentCount={commentCount} board={board} question={question} onCloseRefreshHandler={() => this.props.boardRefreshHandler()} />)}*/}
          {/*{!submissionsClosed(board) && (<AddComment buttonType="icon" commentCount={commentCount} board={board} question={question} onCloseRefreshHandler={() => this.props.boardRefreshHandler()} />)}*/}


          {!submissionsClosed(board) && this.state.isApproved && !excludeComment && (<AddComment buttonType="icon" commentCount={commentCount} board={board} question={question} onCloseRefreshHandler={this.props.boardRefreshHandler} />)}

          {/*<div className="jelly-color-gray-500">*/}
            {/*<i className="fas fa-comment-alt"></i>&nbsp;{commentCount}*/}
          {/*</div>*/}
        </div>

        <div className="col-10 pl-4">
          <div name={uuid} id={uuid} className="">
          {/*<div name={uuid} id={uuid} className="lead text-primary">*/}
            <h5><a href={`/question/${uuid}`}>{title}</a><a className="jelly-pointer ml-2" target="_blank" title="Open in Slack" role="button" href={permalink}><i className="fas fa-external-link-alt text-secondary small" /></a></h5>
            <span></span>
          </div>
          <div className="">{description}</div>
          {/*<div><strong>Discussion</strong></div>*/}
          {/*<InlineComments edges={get(comments, 'edges', [])} pageInfo={get(comments, 'pageInfo', [])}/>*/}

          <div className="py-3 ">
          {/*<div className="text-muted">*/}
            <div><span className="text-muted">{creatorDisplayName} <span className="pdf-no-export">- <TimeAgo date={created} /></span></span></div>
            <div className="mb-3">{board.isModerator && this.renderModeration(board, question)}</div>

            {
              commentCount > 0 && (
                  <div>
                    {/*<div className=""><strong>Discussion</strong></div>*/}
                    <div className="">Discussion</div>
                    <InlineComments edges={get(comments, 'edges', [])} pageInfo={get(comments, 'pageInfo', [])}/>
                  </div>
              )
            }


            {/*<div className="d-inline">*/}
            {/*    <div className="d-inline">{board.isModerator && this.renderModeration(board, question)}</div>*/}
            {/*    <div className="d-inline"></div>*/}
            {/*</div>*/}
              <div>{error && <div className="text-danger">{error}</div>}</div>
          </div>
        </div>
      </div>
    )
  }
}

Question.propTypes = {
  question: PropTypes.object.isRequired,
  board: PropTypes.object.isRequired,
  isLast: PropTypes.bool.isRequired,
  //boardRefreshHandler: PropTypes.func.isRequired,
}

const MODERATE_MUTATION = gql`
  mutation ModerateMutation($uuid: String!, $approve: Boolean!) {
    moderate(uuid: $uuid, approve: $approve) {
      success
      message
      approved
    }
  }
`

const VOTE_MUTATION = gql`
  mutation VoteMutation($questionUuid: String!, $isUp: Boolean!) {
    vote(questionUuid: $questionUuid, isUp: $isUp) {
      success
      message
      question {
        upvotes,
        downvotes,
        isUpvotedByMe
      }
    }
  }
`

// export default graphql(MODERATE_MUTATION)(Question)
export default compose(
    graphql(MODERATE_MUTATION, {
      name: 'moderate',
    }),
    graphql(VOTE_MUTATION, {
      name: 'vote',
    })
)(Question)



// WEBPACK FOOTER //
// ./src/components/Question/index.jsx